import React, {Component} from 'react';
import {InputItem, Modal,Toast} from 'antd-mobile';
import {bindPhone,getPhoneCode,bindChangeCode,changephone} from '../../service/homeService';
import storage from '../../utils/localStore';

import "./style.less";
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
export default class BindingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phone:'',
            code:'',
            getCodeDisabled: false,
            getCodeText: '获取验证码',
        };
    }
    componentDidMount() {
        // console.log(this.props)
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    // 获取验证码
    getCode(type){
        if (phoneReg.test(this.state.phone.replace(/\s/ig, ''))) {
            this.setState({getCodeDisabled: true,});
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    phone: this.state.phone.replace(/\s/ig, ''),
                },
            };
            type(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setDownTime(60);
                } else {
                    this.setState({getCodeDisabled: false,});
                    Toast.info(res.data.msg,3)
                }
            })
        } else {
            Toast.fail('请输入正确的手机号', 2);
        }
    };

    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeText: time + 's后重新获取'});
            } else {
                this.setState({getCodeText: '获取验证码'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };

    bindingBtn = () => {
        if (!phoneReg.test(this.state.phone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的手机号', 2);
        } else if (this.state.code.length !== 4 && this.state.code.length !== 6) {
            Toast.fail('请输入正确的验证码', 2);
        } else {
            Toast.loading("",0);
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    phone: this.state.phone.replace(/\s/ig, ''),
                    smsCode: this.state.code,
                }
            };
            if(this.props.detele){
                changephone(params).then((res)=>{
                    if(res.data.code === '0000'){
                        let usr = {
                            token:this.props.userInfo.token,
                            phone: this.state.phone.replace(/\s/ig, ''),
                            openid: this.props.userInfo.openid,
                            nickname:this.props.userInfo.nickname,
                            avatar:this.props.userInfo.avatar,
                            integral:this.props.userInfo.integral,
                            emergencyContact:this.props.userInfo.emergencyContact,
                            idNum:this.props.userInfo.idNum,
                            couponCount:this.props.userInfo.couponCount,
                            userId:this.props.userInfo.id,
                        };
                        storage.setItem('usr', usr);
                        Toast.info('绑定成功',2,this.props.onClose('ok'));
                    }else{
                        Toast.info(res.data.msg,3)
                    }
                });
            }else{
                bindPhone(params).then((res)=>{
                    if(res.data.code === '0000'){
                        let usr = {
                            token:this.props.userInfo.token,
                            phone: this.state.phone.replace(/\s/ig, ''),
                            openid: this.props.userInfo.openid,
                            nickname:this.props.userInfo.nickname,
                            avatar:this.props.userInfo.avatar,
                            integral:this.props.userInfo.integral,
                            emergencyContact:this.props.userInfo.emergencyContact,
                            idNum:this.props.userInfo.idNum,
                            couponCount:this.props.userInfo.couponCount,
                            userId:this.props.userInfo.id,
                        };
                        storage.setItem('usr', usr);
                        Toast.info('绑定成功', 2, this.props.bindingClick(this.state.phone.replace(/\s/ig, '')));
                    }else{
                        Toast.info(res.data.msg,3)
                    }
                });
            }
        }
    };
    render(){
        return(
            <Modal
                popup
                className="bindingModal"
                visible={this.props.modal}
                // onClose={() => this.props.onClose()}
            >
                <div className="content">
                    <div className="bar"></div>
                    {this.props.detele ?
                        <div className="top" onClick={()=>this.props.onClose()}>绑定手机号  <span>关闭</span>  </div>
                        :<div className="top">绑定手机号</div>
                    }
                    <p>绑定联系手机号码</p>
                    <div className="middle">
                        <InputItem
                            clear
                            type="phone"
                            placeholder="请输入手机号"
                            value={this.state.phone}
                            onChange={v => this.inputChange(v, 'phone')}
                            onBlur={v => window.scroll(0,0)}
                        >
                            手机号:
                        </InputItem>
                        <InputItem
                            clear
                            type="number"
                            maxLength={6}
                            placeholder="请输入验证码"
                            value={this.state.code}
                            onChange={v => this.inputChange(v, 'code')}
                            onBlur={v => window.scroll(0,0)}
                            extra={
                                <button
                                    style={this.state.getCodeDisabled ? {color:"#fff",border:"none"}:null}
                                    disabled={this.state.getCodeDisabled}
                                    onClick={this.props.detele ? ()=>this.getCode(bindChangeCode) : ()=>this.getCode(getPhoneCode)}
                                >{this.state.getCodeText}</button>
                            }
                        >
                            验证码:
                        </InputItem>
                    </div>
                    <div className="bottom" onClick={this.bindingBtn}>{this.props.detele ? '绑定' : '下一步'}</div>
                </div>

            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BindingModal/index.js